import React, { useEffect, useRef, useState } from 'react';

import { 
  Character,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterBackgroundInput from "@dndComponents/character/background/CharacterBackgroundInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  character: Character;
  disabled: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterBackgroundButton({
  character,
  disabled,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [open, setOpen] = useState(false);
  const [flashing, setFlashing] = useState(character.background.source_id === "" || character.background.needs_attention);
  const mounted = useRef(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!fetched) {
      character.subscription_holder.subscribe("Modal Closed", mounted, modalClosed);
      setFetched(true);
    }
    // eslint-disable-next-line
  }, [fetched, setFetched]);

  const modalClosed = () => {
    if (character.background.source_id === "" || character.background.needs_attention) {
      setFlashing(true);
    } else {
      setFlashing(false);
    }
    setReloading(true);
  }

  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        // drawer_only
        width={ wide_mode ? 800 : undefined }
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <>
            <CharacterBackgroundInput
              char={character}
            />
          </>
        }
      </ModalOrDrawer>
    );
  }

  const className = flashing ? "Flashing clickable" : "clickable";
  return (
    <>
      { !reloading &&
        <>
          <div style={{ 
              fontSize: "16px", 
            }}
            className={ disabled ? "" : className }
            onClick={() => {
              if (!disabled) {
                setOpen(true);
              }
            }}>
              { character.background.source ? ` ${char_util.getUseName(character.background)}` : " No Background" } 
          </div>
          <div style={{ 
              fontSize: "10px", 
              color: "gray",
            }}
            className={ disabled ? "" : className }
            onClick={() => {
              if (!disabled) {
                setOpen(true);
              }
            }}>
            Background
          </div>
        </>
      }
      { renderExtras() }
    </>
  ); 
}
